/** Study-guide quiz banks for the Probability Basics and Random Variables guides — 15 MCQs per section. */

export const PS_B_INTRO_QUIZ = [
  {
    prompt: "A fair six-sided die is rolled once. What is $P(\\text{the result is at least }5)$?",
    options: ["$1/6$", "$1/3$", "$1/2$"],
    answer: "B",
    explanation: "Favorable outcomes are $5$ and $6$, so $2/6=1/3$.",
  },
  {
    prompt: "A fair coin is flipped twice. The sample space size is:",
    options: ["$4$", "$3$", "$2$"],
    answer: "A",
    explanation: "Outcomes HH, HT, TH, TT.",
  },
  {
    prompt: "If $P(A)=0.3$, then $P(A^c)$ equals:",
    options: ["$1.3$", "$0.3$", "$0.7$"],
    answer: "C",
    explanation: "Complement rule: $1-0.3=0.7$.",
  },
  {
    prompt: "For events with $P(A)=0.4$, $P(B)=0.5$, $P(A\\cap B)=0.1$, $P(A\\cup B)$ equals:",
    options: ["$0.9$", "$0.8$", "$0.4$"],
    answer: "B",
    explanation: "$0.4+0.5-0.1=0.8$.",
  },
  {
    prompt: "Two events that cannot occur together are called:",
    options: ["Independent", "Complements only if probabilities match", "Disjoint (mutually exclusive)"],
    answer: "C",
    explanation: "Disjoint means empty intersection.",
  },
  {
    prompt: "A spinner with four equal sectors labeled $1$–$4$ gives $P(\\text{even})$:",
    options: ["$1/2$", "$1/4$", "$3/4$"],
    answer: "A",
    explanation: "Sectors $2$ and $4$ of four equally likely outcomes.",
  },
  {
    prompt: "From a standard $52$-card deck, $P(\\text{drawing an ace})$ equals:",
    options: ["$1/13$", "$1/52$", "$4/13$"],
    answer: "A",
    explanation: "$4$ aces among $52$ cards: $4/52=1/13$.",
  },
  {
    prompt: "If odds in favor of $E$ are $2:1$, then $P(E)$ equals:",
    options: ["$2$", "$2/3$", "$1/2$"],
    answer: "B",
    explanation: "Odds $a:b$ mean probability $a/(a+b)$.",
  },
  {
    prompt: "For a fair die, $P(\\text{prime face})$ with primes $\\{2,3,5\\}$ equals:",
    options: ["$2/3$", "$1/3$", "$1/2$"],
    answer: "C",
    explanation: "Three of six faces.",
  },
  {
    prompt: "If $A$ and $B$ are disjoint and $P(A)=0.2$, $P(B)=0.3$, then $P(A\\cup B)$ equals:",
    options: ["$0.06$", "$0.5$", "$0.1$"],
    answer: "B",
    explanation: "Add probabilities when the intersection is empty.",
  },
  {
    prompt: "A sample space for one roll of a fair tetrahedral die labeled $1$–$4$ is:",
    options: ["$\\{0,1,2,3\\}$", "$\\{1,2\\}$", "$\\{1,2,3,4\\}$"],
    answer: "C",
    explanation: "The four face values.",
  },
  {
    prompt: "Axiomatically, probabilities of outcomes in a finite sample space must:",
    options: ["Be nonnegative and sum to $1$", "Each equal $1/2$", "All be zero"],
    answer: "A",
    explanation: "Nonnegativity and normalization.",
  },
  {
    prompt: "If $P(A\\cup B)=0.9$, $P(A)=0.6$, $P(B)=0.5$, then $P(A\\cap B)$ equals:",
    options: ["$0.4$", "$1.1$", "$0.2$"],
    answer: "C",
    explanation: "Rearrange inclusion-exclusion: $0.6+0.5-0.9=0.2$.",
  },
  {
    prompt: "Drawing one card, $P(\\text{heart or king})$ equals:",
    options: ["$16/52$", "$13/52$", "$17/52$"],
    answer: "A",
    explanation: "$13$ hearts plus $3$ non-heart kings: $16/52$.",
  },
  {
    prompt: "For any event $A$, $P(A)$ lies in:",
    options: ["$(-1,1)$", "$[0,1]$", "$(1,\\infty)$"],
    answer: "B",
    explanation: "Probability bounds from the axioms.",
  },

  {
    prompt: "A fair die is rolled. What is $P(\\text{result}<3)$?",
    options: ["$1/3$", "$1/2$", "$2/3$"],
    answer: "A",
    explanation: "The favorable outcomes are $1,2$, so the probability is $2/6=1/3$.",
  },
  {
    prompt: "If $P(A)=0.65$, then $P(A^c)$ is:",
    options: ["$0.65$", "$0.35$", "$1.65$"],
    answer: "B",
    explanation: "Complement rule: $1-0.65=0.35$.",
  },
  {
    prompt: "If $A$ and $B$ are disjoint with probabilities $0.25$ and $0.40$, then $P(A\\cup B)$ is:",
    options: ["$0.10$", "$0.15$", "$0.65$"],
    answer: "C",
    explanation: "For disjoint events, add the probabilities.",
  },
  {
    prompt: "For any sample space $S$, $P(S)$ equals:",
    options: ["$1$", "$0$", "$1/2$"],
    answer: "A",
    explanation: "Normalization is one of the probability axioms.",
  },
  {
    prompt: "If $A\\subseteq B$, which inequality must hold?",
    options: ["$P(A)>P(B)$", "$P(A)\\le P(B)$", "$P(A)+P(B)=0$"],
    answer: "B",
    explanation: "Probability is monotone with respect to set inclusion.",
  },
];

export const PS_B_COMBO_QUIZ = [
  {
    prompt: "The number of ways to choose $2$ committee members from $5$ people is:",
    options: ["$10$", "$5$", "$20$"],
    answer: "A",
    explanation: "$\\binom{5}{2}=10$.",
  },
  {
    prompt: "$P(5,2)$ equals:",
    options: ["$10$", "$25$", "$20$"],
    answer: "C",
    explanation: "$5\\times 4=20$.",
  },
  {
    prompt: "A password of $3$ distinct digits has how many possibilities?",
    options: ["$10^3=1000$", "$10\\times 9\\times 8=720$", "$\\binom{10}{3}$"],
    answer: "B",
    explanation: "Ordered without repetition.",
  },
  {
    prompt: "Arrangements of the letters in MISSISSIPPI: number of distinct permutations is:",
    options: ["$\\binom{11}{4}$", "$11!$", "$\\dfrac{11!}{4!4!2!}$"],
    answer: "C",
    explanation: "Account for repeated I, S, and P.",
  },
  {
    prompt: "From $52$ cards, ways to choose a $5$-card hand:",
    options: ["$P(52,5)$", "$\\binom{52}{5}$", "$52^5$"],
    answer: "B",
    explanation: "Unordered hands use combinations.",
  },
  {
    prompt: "A fair coin flipped $3$ times: $P(\\text{exactly two heads})$ equals:",
    options: ["$3/8$", "$1/2$", "$1/8$"],
    answer: "A",
    explanation: "$\\binom{3}{2}/8=3/8$.",
  },
  {
    prompt: "Multiplication principle: $4$ shirts and $3$ pants give how many outfits?",
    options: ["$4$", "$7$", "$12$"],
    answer: "C",
    explanation: "$4\\times 3=12$.",
  },
  {
    prompt: "$\\binom{6}{3}$ equals:",
    options: ["$18$", "$20$", "$120$"],
    answer: "B",
    explanation: "$6!/(3!3!)=20$.",
  },
  {
    prompt: "Number of injective functions from a $2$-set to a $5$-set is:",
    options: ["$20$", "$25$", "$10$"],
    answer: "A",
    explanation: "$P(5,2)=20$.",
  },
  {
    prompt: "A bag has $3$ red and $2$ blue marbles. Probability both drawn (without replacement, order ignored) are red:",
    options: ["$\\binom{3}{2}/\\binom{5}{2}=3/10$", "$3/5$", "$2/5$"],
    answer: "A",
    explanation: "Favorable pairs over total pairs.",
  },
  {
    prompt: "License plates with $2$ letters then $3$ digits (repeats allowed, $26$ letters) count:",
    options: ["$26\\cdot 25\\cdot 10\\cdot 9\\cdot 8$", "$26^2\\cdot 10^3$", "$P(26,2)\\cdot P(10,3)$ only"],
    answer: "B",
    explanation: "Independent choices with repetition.",
  },
  {
    prompt: "Ways to seat $4$ people in $4$ chairs in a row:",
    options: ["$16$", "$4$", "$24$"],
    answer: "C",
    explanation: "$4!=24$.",
  },
  {
    prompt: "Probability a random permutation of $\\{1,2,3\\}$ is sorted ascending:",
    options: ["$1/2$", "$1/6$", "$1/3$"],
    answer: "B",
    explanation: "One of $6$ permutations.",
  },
  {
    prompt: "$\\binom{10}{0}$ equals:",
    options: ["$10$", "$0$", "$1$"],
    answer: "C",
    explanation: "One way to choose nothing.",
  },
  {
    prompt: "Choosing a president and treasurer from $8$ distinct people (different roles):",
    options: ["$P(8,2)=56$", "$\\binom{8}{2}=28$", "$8$"],
    answer: "A",
    explanation: "Order of roles matters.",
  },

  {
    prompt: "The number of ways to arrange $4$ distinct books is:",
    options: ["$16$", "$24$", "$4$"],
    answer: "B",
    explanation: "$4!=24$.",
  },
  {
    prompt: "The number of ways to choose $3$ students from $7$ is:",
    options: ["$21$", "$210$", "$35$"],
    answer: "C",
    explanation: "$\\binom{7}{3}=35$.",
  },
  {
    prompt: "How many ordered pairs of distinct items can be chosen from $6$ items?",
    options: ["$30$", "$15$", "$36$"],
    answer: "A",
    explanation: "$P(6,2)=6\\cdot5=30$.",
  },
  {
    prompt: "How many binary strings of length $5$ are possible?",
    options: ["$10$", "$32$", "$25$"],
    answer: "B",
    explanation: "Each position has $2$ choices, so $2^5=32$.",
  },
  {
    prompt: "The number of distinct permutations of AABC is:",
    options: ["$24$", "$6$", "$12$"],
    answer: "C",
    explanation: "$4!/2!=12$ because A repeats twice.",
  },
];

export const PS_B_COND_QUIZ = [
  {
    prompt: "If $P(A\\cap B)=0.1$ and $P(B)=0.5$, then $P(A\\mid B)$ equals:",
    options: ["$0.5$", "$0.2$", "$0.1$"],
    answer: "B",
    explanation: "$0.1/0.5=0.2$.",
  },
  {
    prompt: "A fair die is rolled. $P(\\text{even}\\mid \\text{at least }4)$ equals:",
    options: ["$2/3$", "$1/2$", "$1/3$"],
    answer: "A",
    explanation: "Conditioning on $\\{4,5,6\\}$; even among them: $4,6$.",
  },
  {
    prompt: "Two cards without replacement from a $52$-card deck: $P(\\text{second ace}\\mid\\text{first ace})$ equals:",
    options: ["$4/52$", "$3/52$", "$3/51$"],
    answer: "C",
    explanation: "Three aces remain among $51$ cards.",
  },
  {
    prompt: "Events $A,B$ are independent if:",
    options: ["$P(A\\cup B)=P(A)+P(B)$", "$P(A\\mid B)=0$", "$P(A\\cap B)=P(A)P(B)$"],
    answer: "C",
    explanation: "Product rule characterization.",
  },
  {
    prompt: "From a two-way table: $60$ men, $40$ women; $18$ men and $12$ women own pets. $P(\\text{owns pet}\\mid\\text{woman})$ equals:",
    options: ["$12/40=0.3$", "$30/100$", "$18/60$"],
    answer: "A",
    explanation: "Restrict to the $40$ women.",
  },
  {
    prompt: "Law of total probability with partition $\\{B,B^c\\}$: $P(A)$ equals:",
    options: ["$P(A\\mid B)$ only", "$P(A\\mid B)P(B)+P(A\\mid B^c)P(B^c)$", "$P(B\\mid A)$"],
    answer: "B",
    explanation: "Average the conditional probabilities.",
  },
  {
    prompt: "If $P(A)=0.4$, $P(B)=0.5$, and $A,B$ independent, $P(A\\cap B)$ equals:",
    options: ["$0.1$", "$0.9$", "$0.2$"],
    answer: "C",
    explanation: "$0.4\\times 0.5=0.2$.",
  },
  {
    prompt: "A bag has $2$ white and $3$ black balls. Draw two without replacement. $P(\\text{second white}\\mid\\text{first black})$ equals:",
    options: ["$2/4$", "$2/5$", "$3/4$"],
    answer: "A",
    explanation: "After a black draw, $2$ white among $4$ left.",
  },
  {
    prompt: "Multiplication rule: $P(A\\cap B)$ equals:",
    options: ["$P(A)+P(B)$", "$P(A\\mid B)P(B)$", "$P(A)/P(B)$"],
    answer: "B",
    explanation: "Definition of conditional probability rearranged.",
  },
  {
    prompt: "If $P(A\\mid B)=P(A)$, then $A$ and $B$ are:",
    options: ["Independent (when $P(B)>0$)", "Disjoint", "Complements"],
    answer: "A",
    explanation: "Conditional equals marginal.",
  },
  {
    prompt: "An urn holds $4$ red and $6$ blue balls. Given the ball is not blue, $P(\\text{red})$ equals:",
    options: ["$4/10$", "$1$", "$0$"],
    answer: "B",
    explanation: "Not blue means the ball is red.",
  },
  {
    prompt: "Two fair dice: $P(\\text{sum }=7\\mid\\text{first die shows }2)$ equals:",
    options: ["$1/12$", "$1/2$", "$1/6$"],
    answer: "C",
    explanation: "Need second die to show $5$; one of six faces.",
  },
  {
    prompt: "Sampling with replacement: successive draws are typically modeled as:",
    options: ["Complements", "Mutually exclusive", "Independent"],
    answer: "C",
    explanation: "Restoring the item keeps probabilities fixed.",
  },
  {
    prompt: "If $P(B)=0$, then $P(A\\mid B)$ is:",
    options: ["Undefined", "$0$", "$1$"],
    answer: "A",
    explanation: "Cannot condition on a zero-probability event.",
  },
  {
    prompt: "Partition check: if $P(A\\mid B_1)=0.2$, $P(A\\mid B_2)=0.5$, $P(B_1)=P(B_2)=1/2$, then $P(A)$ equals:",
    options: ["$0.7$", "$0.35$", "$0.2$"],
    answer: "B",
    explanation: "$0.2\\cdot 1/2+0.5\\cdot 1/2=0.35$.",
  },

  {
    prompt: "If $P(A\\cap B)=0.2$ and $P(B)=0.5$, then $P(A\\mid B)$ is:",
    options: ["$0.1$", "$0.7$", "$0.4$"],
    answer: "C",
    explanation: "$P(A|B)=P(A\\cap B)/P(B)=0.2/0.5=0.4$.",
  },
  {
    prompt: "Events $A$ and $B$ are independent when:",
    options: ["$P(A\\cap B)=P(A)P(B)$", "$P(A\\cap B)=0$ always", "$P(A)=P(B)$"],
    answer: "A",
    explanation: "This product rule is the standard independence criterion.",
  },
  {
    prompt: "If $P(A)=0.3$ and $P(B)=0.4$ are independent, $P(A\\cap B)$ is:",
    options: ["$0.7$", "$0.12$", "$0.1$"],
    answer: "B",
    explanation: "Multiply: $0.3\\times0.4=0.12$.",
  },
  {
    prompt: "If $A$ and $B$ are independent and $P(B)>0$, then $P(A\\mid B)$ equals:",
    options: ["$P(B)$", "$0$", "$P(A)$"],
    answer: "C",
    explanation: "Knowing $B$ occurred does not change the probability of $A$.",
  },
  {
    prompt: "Two disjoint events with positive probabilities are:",
    options: ["Not independent", "Always independent", "Always complements"],
    answer: "A",
    explanation: "Disjointness gives intersection probability zero, but independence would require a positive product.",
  },
];

export const PS_B_BAYES_QUIZ = [
  {
    prompt: "A disease has prevalence $1\\%$. A test is $99\\%$ sensitive and $95\\%$ specific. Approximate $P(\\text{disease}\\mid +)$ is closest to:",
    options: ["About $0.17$", "About $0.99$", "About $0.01$"],
    answer: "A",
    explanation: "Bayes: with $10000$ people, about $99$ true $+$ and $495$ false $+$; $99/(99+495)\\approx 0.17$.",
  },
  {
    prompt: "Bayes' theorem states $P(H\\mid E)$ equals:",
    options: ["$P(H)/P(E)$", "$\\dfrac{P(E\\mid H)P(H)}{P(E)}$", "$P(E\\mid H)$"],
    answer: "B",
    explanation: "Posterior proportional to likelihood times prior.",
  },
  {
    prompt: "Prior $P(H)=0.2$, likelihood $P(E\\mid H)=0.6$, $P(E\\mid H^c)=0.1$. Then $P(E)$ equals:",
    options: ["$0.08$", "$0.12$", "$0.2$"],
    answer: "C",
    explanation: "$0.6\\cdot 0.2+0.1\\cdot 0.8=0.12+0.08=0.2$.",
  },
  {
    prompt: "Using the previous numbers, $P(H\\mid E)$ equals:",
    options: ["$0.2$", "$0.12$", "$0.6$"],
    answer: "C",
    explanation: "$(0.6\\cdot 0.2)/0.2=0.6$.",
  },
  {
    prompt: "In a spam filter, $P(\\text{spam})=0.4$, $P(\\text{word}\\mid\\text{spam})=0.5$, $P(\\text{word}\\mid\\text{ham})=0.1$. Then $P(\\text{spam}\\mid\\text{word})$ equals:",
    options: ["$1/2$", "$10/13$", "$4/10$"],
    answer: "B",
    explanation: "$P(\\text{word})=0.5\\cdot 0.4+0.1\\cdot 0.6=0.26$; posterior $0.2/0.26=10/13$.",
  },
  {
    prompt: "Rare conditions yield many false positives because:",
    options: ["The base rate is low relative to the false-positive mass", "Specificity exceeds $1$", "Sensitivity must be zero"],
    answer: "A",
    explanation: "Even a small false-positive rate hits many healthy people.",
  },
  {
    prompt: "Factory: lines A,B produce $60\\%$ and $40\\%$ of items; defect rates $2\\%$ and $5\\%$. $P(\\text{from A}\\mid\\text{defect})$ equals:",
    options: ["$3/8$", "$2/5$", "$6/10$"],
    answer: "A",
    explanation: "$P(D)=0.012+0.02=0.032$; $P(A\\mid D)=0.012/0.032=3/8$.",
  },
  {
    prompt: "After observing evidence, the updated probability of a hypothesis is the:",
    options: ["Prior only", "Posterior", "Likelihood alone"],
    answer: "B",
    explanation: "Posterior $=P(H\\mid E)$.",
  },
  {
    prompt: "Three hypotheses $H_1,H_2,H_3$ with posteriors $0.2$, $0.5$, $0.3$ after data. They sum to:",
    options: ["$1.5$", "$0.5$", "$1$"],
    answer: "C",
    explanation: "A complete posterior distribution normalizes to $1$.",
  },
  {
    prompt: "Likelihood $P(E\\mid H)$ is:",
    options: ["The prior", "Always equal to the posterior", "Probability of the evidence given the hypothesis"],
    answer: "C",
    explanation: "It is not the same as $P(H\\mid E)$.",
  },
  {
    prompt: "Updating twice with independent reports multiplies likelihood factors into the:",
    options: ["Sample space size only", "Posterior (up to renormalization)", "Prior without change"],
    answer: "B",
    explanation: "Sequential Bayes multiplies likelihoods.",
  },
  {
    prompt: "If prior odds of $H$ are $1:3$ and the likelihood ratio $P(E\\mid H)/P(E\\mid H^c)=6$, posterior odds are:",
    options: ["$2:1$", "$1:18$", "$6:3$"],
    answer: "A",
    explanation: "Posterior odds $=$ prior odds $\\times$ likelihood ratio: $(1/3)\\times 6=2$.",
  },
  {
    prompt: "Medical test: $P(+\\mid D)=0.9$, $P(+\\mid D^c)=0.2$, $P(D)=0.1$. Then $P(D\\mid +)$ equals:",
    options: ["$0.1$", "$0.9$", "$1/3$"],
    answer: "C",
    explanation: "$P(+)=0.09+0.18=0.27$, so $0.09/0.27=1/3$.",
  },
  {
    prompt: "A sensor false-alarm rate is $P(+\\mid\\text{no event})=0.01$ with rare events. Without Bayes one might wrongly treat:",
    options: ["$P(+\\mid\\text{no event})$ as if it were $P(\\text{event}\\mid +)$", "Sensitivity as specificity", "Prevalence as $1$"],
    answer: "A",
    explanation: "Confusing $P(+\\mid H^c)$ with $P(H\\mid +)$.",
  },
  {
    prompt: "If new evidence has likelihood ratio $1$ for $H$ vs $H^c$, the posterior equals:",
    options: ["Zero", "The prior", "One"],
    answer: "B",
    explanation: "Uninformative evidence leaves beliefs unchanged.",
  },

  {
    prompt: "Bayes' theorem computes $P(A\\mid B)$ from:",
    options: ["$P(B\\mid A)P(A)/P(B)$", "$P(A)P(B)$", "$P(B)-P(A)$"],
    answer: "A",
    explanation: "Bayes reverses the conditioning direction.",
  },
  {
    prompt: "If $P(D)=0.1$, $P(+|D)=0.9$, and $P(+)=0.2$, then $P(D|+)$ is:",
    options: ["$0.18$", "$0.45$", "$0.90$"],
    answer: "B",
    explanation: "Bayes gives $0.9(0.1)/0.2=0.45$.",
  },
  {
    prompt: "For a partition $A_1,\\ldots,A_k$, the law of total probability gives $P(B)$ as:",
    options: ["$\\prod_i P(B|A_i)$", "$P(B|A_1)$ only", "$\\sum_i P(B|A_i)P(A_i)$"],
    answer: "C",
    explanation: "Sum the contributions from mutually exclusive exhaustive cases.",
  },
  {
    prompt: "A prior probability in Bayesian reasoning is the probability:",
    options: ["Before observing the new evidence", "After conditioning on the evidence", "That must equal one"],
    answer: "A",
    explanation: "The prior encodes belief before the current evidence is incorporated.",
  },
  {
    prompt: "A posterior probability is obtained:",
    options: ["Before any evidence", "After updating with observed evidence", "By ignoring the likelihood"],
    answer: "B",
    explanation: "Bayes' theorem combines prior information with the likelihood to produce the posterior.",
  },
];

export const PS_RV_INTRO_QUIZ = [
  {
    prompt: "A pmf $p(x)$ on a discrete support must satisfy:",
    options: ["$p(x)\\ge 0$ and $\\sum p(x)=1$", "$p(x)\\le 0$", "$\\sum p(x)=0$"],
    answer: "A",
    explanation: "Nonnegative probabilities summing to one.",
  },
  {
    prompt: "For $X$ with $P(X=1)=0.2$, $P(X=2)=0.5$, $P(X=3)=0.3$, $P(X\\le 2)$ equals:",
    options: ["$0.5$", "$0.3$", "$0.7$"],
    answer: "C",
    explanation: "$0.2+0.5=0.7$.",
  },
  {
    prompt: "The cdf $F(a)=P(X\\le a)$. If $F(2)=0.4$ and $F(3)=0.9$ for integer-valued $X$, then $P(X=3)$ equals:",
    options: ["$0.9$", "$0.5$", "$0.4$"],
    answer: "B",
    explanation: "$F(3)-F(2)=0.5$.",
  },
  {
    prompt: "Support of a discrete RV is:",
    options: ["Only the mean", "The set of values with positive probability", "Always all real numbers"],
    answer: "B",
    explanation: "Where the pmf is positive.",
  },
  {
    prompt: "An indicator $I_A$ equals $1$ on $A$ and $0$ otherwise. Then $E[I_A]$ equals:",
    options: ["$0$", "$1$", "$P(A)$"],
    answer: "C",
    explanation: "Expectation of an indicator is the probability.",
  },
  {
    prompt: "Fair die $X$: $P(X=6)$ equals:",
    options: ["$1/6$", "$1$", "$1/2$"],
    answer: "A",
    explanation: "Six equally likely faces.",
  },
  {
    prompt: "If $p(0)=0.4$, $p(1)=0.4$, $p(2)=0.3$, this cannot be a pmf because:",
    options: ["The support is finite", "Some values are positive", "The values sum to $1.1\\ne 1$"],
    answer: "C",
    explanation: "Probabilities must sum to $1$.",
  },
  {
    prompt: "For a fair coin, let $X=1$ for heads and $0$ for tails. Then $P(X=1)$ equals:",
    options: ["$1/2$", "$0$", "$1$"],
    answer: "A",
    explanation: "Fair coin.",
  },
  {
    prompt: "If $X$ takes values $1,2,3$ equally likely, $P(X\\ge 2)$ equals:",
    options: ["$1/3$", "$2/3$", "$1$"],
    answer: "B",
    explanation: "Two of three outcomes.",
  },
  {
    prompt: "A valid assignment $p(1)=1/2$, $p(2)=1/3$, $p(3)=1/6$ is a pmf because:",
    options: ["They are all equal", "Entries are nonnegative and sum to $1$", "The mean is $2$"],
    answer: "B",
    explanation: "$1/2+1/3+1/6=1$.",
  },
  {
    prompt: "For discrete $X$, $P(X<a)$ for integer $a$ equals:",
    options: ["$F(a)$", "$1-F(a)$ always", "$F(a-1)$ when $X$ is integer-valued"],
    answer: "C",
    explanation: "Strict inequality stops at $a-1$.",
  },
  {
    prompt: "Two independent fair coin indicators $I,J$: $P(I+J=2)$ equals:",
    options: ["$1/4$", "$1/2$", "$1$"],
    answer: "A",
    explanation: "Both heads: $(1/2)^2$.",
  },
  {
    prompt: "The pmf of a constant $X=7$ is:",
    options: ["$p(x)=1/7$ for all $x$", "$p(7)=7$", "$p(7)=1$"],
    answer: "C",
    explanation: "All mass at a single point.",
  },
  {
    prompt: "If $F$ is a cdf of discrete $X$, then $F$ is:",
    options: ["Nondecreasing and right-continuous with jumps at atoms", "Always continuous", "Always strictly decreasing"],
    answer: "A",
    explanation: "Discrete cdfs jump at support points.",
  },
  {
    prompt: "Construct pmf from rolling a die and setting $Y=1$ if face $>4$, else $0$. Then $P(Y=1)$ equals:",
    options: ["$2/3$", "$1/3$", "$1/2$"],
    answer: "B",
    explanation: "Faces $5,6$ of six.",
  },

  {
    prompt: "A discrete random variable is described by a PMF $p(x)$ satisfying:",
    options: ["$p(x)<0$ for some $x$", "$p(x)\\ge0$ and $\\sum_xp(x)=1$", "$\\sum_xp(x)=0$"],
    answer: "B",
    explanation: "Probabilities must be nonnegative and total one.",
  },
  {
    prompt: "The CDF is defined by:",
    options: ["$F(x)=P(X=x)$ only", "$F(x)=E[X]$", "$F(x)=P(X\\le x)$"],
    answer: "C",
    explanation: "The cumulative distribution function accumulates probability up to $x$.",
  },
  {
    prompt: "Every CDF is:",
    options: ["Nondecreasing", "Strictly decreasing", "Allowed to exceed one"],
    answer: "A",
    explanation: "Events $\\{X\\le x\\}$ grow as $x$ increases.",
  },
  {
    prompt: "For a discrete random variable, $E[X]$ equals:",
    options: ["$\\sum_x p(x)$", "$\\sum_x x p(x)$", "$\\prod_x xp(x)$"],
    answer: "B",
    explanation: "Expectation is the probability-weighted average of possible values.",
  },
  {
    prompt: "If $X$ is constant with value $c$, then $E[X]$ is:",
    options: ["$0$", "$c^2$", "$c$"],
    answer: "C",
    explanation: "A constant random variable always takes the value $c$.",
  },
];

export const PS_RV_MOMENTS_QUIZ = [
  {
    prompt: "For $X$ with $P(X=1)=0.2$, $P(X=2)=0.5$, $P(X=3)=0.3$, $E[X]$ equals:",
    options: ["$1.5$", "$2$", "$2.1$"],
    answer: "C",
    explanation: "$1\\cdot 0.2+2\\cdot 0.5+3\\cdot 0.3=2.1$.",
  },
  {
    prompt: "If $E[X]=2$ and $E[X^2]=5$, then $\\operatorname{Var}(X)$ equals:",
    options: ["$1$", "$3$", "$5$"],
    answer: "A",
    explanation: "$5-2^2=1$.",
  },
  {
    prompt: "Standard deviation is:",
    options: ["$E[X]$", "$\\sqrt{\\operatorname{Var}(X)}$", "$\\operatorname{Var}(X)$"],
    answer: "B",
    explanation: "Square root of variance.",
  },
  {
    prompt: "If $E[X]=4$, then $E[3X+1]$ equals:",
    options: ["$12$", "$13$", "$7$"],
    answer: "B",
    explanation: "Linearity: $3\\cdot 4+1=13$.",
  },
  {
    prompt: "$\\operatorname{Var}(3X+1)$ equals:",
    options: ["$9\\operatorname{Var}(X)$", "$\\operatorname{Var}(X)+1$", "$3\\operatorname{Var}(X)$"],
    answer: "A",
    explanation: "Constants shift mean only; variance scales by $a^2$.",
  },
  {
    prompt: "A game pays $5$ dollars with probability $1/2$ and $0$ otherwise. Expected payout is:",
    options: ["$0$ dollars", "$5$ dollars", "$2.5$ dollars"],
    answer: "C",
    explanation: "$5\\cdot 1/2=2.5$.",
  },
  {
    prompt: "For independent $X,Y$, $\\operatorname{Var}(X+Y)$ equals:",
    options: ["$\\operatorname{Var}(X)\\operatorname{Var}(Y)$", "$\\operatorname{Var}(X)+\\operatorname{Var}(Y)$", "$\\operatorname{Var}(X)-\\operatorname{Var}(Y)$"],
    answer: "B",
    explanation: "Variances add under independence.",
  },
  {
    prompt: "Bernoulli $X$ with $P(X=1)=p$ has variance:",
    options: ["$p(1-p)$", "$1-p$", "$p$"],
    answer: "A",
    explanation: "$E[X^2]=p$ and $E[X]=p$.",
  },
  {
    prompt: "If $X$ takes $-1$ and $1$ each with probability $1/2$, $\\operatorname{Var}(X)$ equals:",
    options: ["$1/2$", "$0$", "$1$"],
    answer: "C",
    explanation: "$E[X]=0$, $E[X^2]=1$.",
  },
  {
    prompt: "$E[X-E[X]]$ equals:",
    options: ["$\\operatorname{Var}(X)$", "$0$", "$E[X]$"],
    answer: "B",
    explanation: "Centered variable has mean zero.",
  },
  {
    prompt: "If $\\operatorname{Var}(X)=4$, then $\\operatorname{Var}(X/2)$ equals:",
    options: ["$2$", "$4$", "$1$"],
    answer: "C",
    explanation: "$(1/2)^2\\cdot 4=1$.",
  },
  {
    prompt: "For $X$ uniform on $\\{1,2,3,4\\}$, $E[X]$ equals:",
    options: ["$2.5$", "$1$", "$4$"],
    answer: "A",
    explanation: "Average of $1$ through $4$.",
  },
  {
    prompt: "A raffle: win $10$ dollars with probability $0.1$, else $0$. Expected gain is:",
    options: ["$10$ dollars", "$0.1$ dollars", "$1$ dollar"],
    answer: "C",
    explanation: "$10\\cdot 0.1=1$.",
  },
  {
    prompt: "If $X$ and $Y$ are independent with variances $2$ and $3$, $\\operatorname{Var}(X-Y)$ equals:",
    options: ["$-1$", "$5$", "$1$"],
    answer: "B",
    explanation: "$\\operatorname{Var}(X)+\\operatorname{Var}(-Y)=2+3$.",
  },
  {
    prompt: "Given pmf $p(0)=1/2$, $p(4)=1/2$, $E[X^2]$ equals:",
    options: ["$8$", "$4$", "$2$"],
    answer: "A",
    explanation: "$0+16\\cdot 1/2=8$.",
  },

  {
    prompt: "Variance can be computed as:",
    options: ["$E[X^2]+(E[X])^2$", "$E[X]$", "$E[X^2]-(E[X])^2$"],
    answer: "C",
    explanation: "This identity follows from expanding $E[(X-\\mu)^2]$.",
  },
  {
    prompt: "The standard deviation of $X$ is:",
    options: ["$\\sqrt{\\operatorname{Var}(X)}$", "$\\operatorname{Var}(X)^2$", "$E[X]^2$"],
    answer: "A",
    explanation: "Standard deviation is the square root of variance.",
  },
  {
    prompt: "For constants $a,b$, $E[aX+b]$ equals:",
    options: ["$a^2E[X]+b$", "$aE[X]+b$", "$E[X]+ab$"],
    answer: "B",
    explanation: "Expectation is linear.",
  },
  {
    prompt: "For constants $a,b$, $\\operatorname{Var}(aX+b)$ equals:",
    options: ["$a\\operatorname{Var}(X)+b$", "$\\operatorname{Var}(X)+b^2$", "$a^2\\operatorname{Var}(X)$"],
    answer: "C",
    explanation: "Shifts do not affect spread; scaling by $a$ scales variance by $a^2$.",
  },
  {
    prompt: "The moment generating function is defined by:",
    options: ["$M_X(t)=E[e^{tX}]$", "$E[X^t]$", "$E[tX]$"],
    answer: "A",
    explanation: "The MGF encodes moments through derivatives at zero when it exists.",
  },
];

export const PS_RV_CONT_QUIZ = [
  {
    prompt: "A pdf $f$ on $\\mathbb{R}$ must satisfy $f\\ge 0$ and:",
    options: ["$\\sum f(x)=1$", "$\\int_{-\\infty}^{\\infty}f(x)\\,dx=1$", "$f(x)\\le 1$ everywhere"],
    answer: "B",
    explanation: "Continuous analogue of a pmf.",
  },
  {
    prompt: "If $f(x)=c$ on $[0,2]$ and $0$ elsewhere, the normalizing $c$ equals:",
    options: ["$1$", "$2$", "$1/2$"],
    answer: "C",
    explanation: "$\\int_0^2 c\\,dx=2c=1$.",
  },
  {
    prompt: "For that uniform density, $P(0.5<X<1.5)$ equals:",
    options: ["$1/2$", "$1$", "$1/4$"],
    answer: "A",
    explanation: "Length $1$ times height $1/2$.",
  },
  {
    prompt: "For a continuous RV, $P(X=c)$ equals:",
    options: ["$0$", "$F(c)$", "$f(c)$"],
    answer: "A",
    explanation: "Points have probability zero under a density.",
  },
  {
    prompt: "If $F$ is the cdf, then $f(x)$ equals:",
    options: ["$F(x)$", "$1-F(x)$", "$F'(x)$ at continuity points of $f$"],
    answer: "C",
    explanation: "Density is the derivative of the cdf.",
  },
  {
    prompt: "Exponential pdf $f(x)=\\lambda e^{-\\lambda x}$ for $x>0$. If $\\lambda=2$, $P(X>1)$ equals:",
    options: ["$2e^{-2}$", "$e^{-2}$", "$1-e^{-2}$"],
    answer: "B",
    explanation: "Survival $e^{-\\lambda x}$.",
  },
  {
    prompt: "Uniform on $[0,1]$: $E[X]$ equals:",
    options: ["$1$", "$1/2$", "$0$"],
    answer: "B",
    explanation: "$\\int_0^1 x\\,dx=1/2$.",
  },
  {
    prompt: "Median $m$ of a continuous RV satisfies:",
    options: ["$F(m)=1/2$", "$E[X]=m$ always", "$f(m)=1/2$"],
    answer: "A",
    explanation: "Half the mass on each side.",
  },
  {
    prompt: "Pdf $f(x)=3x^2$ on $[0,1]$: $P(X<1/2)$ equals:",
    options: ["$3/8$", "$1/2$", "$1/8$"],
    answer: "C",
    explanation: "$\\int_0^{1/2}3x^2\\,dx=(1/2)^3=1/8$.",
  },
  {
    prompt: "For continuous $X$, $P(a\\le X\\le b)$ equals:",
    options: ["$f(b)-f(a)$", "$F(a)-F(b)$", "$\\int_a^b f(x)\\,dx$"],
    answer: "C",
    explanation: "Integrate the density.",
  },
  {
    prompt: "Exponential with mean $2$ has rate $\\lambda$ equal to:",
    options: ["$1$", "$1/2$", "$2$"],
    answer: "B",
    explanation: "Mean $1/\\lambda$.",
  },
  {
    prompt: "If $f(x)=0$ for $x<0$ and $x>1$, and $f(x)=2x$ on $[0,1]$, then $\\int f=1$ holds because:",
    options: ["$\\int_0^1 2x\\,dx=1$", "$2\\cdot 1=2$", "$f(1)=2$"],
    answer: "A",
    explanation: "Check normalization.",
  },
  {
    prompt: "Cdf of Uniform$[0,2]$ at $x=1$ equals:",
    options: ["$1$", "$1/2$", "$2$"],
    answer: "B",
    explanation: "$F(x)=x/2$ on the interval.",
  },
  {
    prompt: "Expectation $\\int_{-\\infty}^{\\infty} x f(x)\\,dx$ for a pdf $f$ is:",
    options: ["$E[X]$", "$F(x)$", "$\\operatorname{Var}(X)$"],
    answer: "A",
    explanation: "Definition of the mean for continuous RVs.",
  },
  {
    prompt: "If $X$ has pdf $f(x)=e^{-x}$ for $x>0$, the median solves $1-e^{-m}=1/2$, so $m$ equals:",
    options: ["$1/2$", "$1$", "$\\ln 2$"],
    answer: "C",
    explanation: "$e^{-m}=1/2$.",
  },

  {
    prompt: "For a continuous PDF $f(x)$, total area satisfies:",
    options: ["$\\int_{-\\infty}^{\\infty}f(x)dx=1$", "$0$", "$f(x)=1$ for all $x$"],
    answer: "A",
    explanation: "A density integrates to total probability one.",
  },
  {
    prompt: "For a continuous random variable, $P(X=x_0)$ is:",
    options: ["$1$", "$0$", "$f(x_0)$ always"],
    answer: "B",
    explanation: "A single point has zero area under a continuous density.",
  },
  {
    prompt: "For continuous $X$, $P(a<X<b)$ equals:",
    options: ["$f(b)-f(a)$", "$f(a)f(b)$", "$\\int_a^b f(x)dx$"],
    answer: "C",
    explanation: "Interval probability is area under the PDF.",
  },
  {
    prompt: "If $F$ is differentiable, the PDF is obtained from the CDF by:",
    options: ["$f(x)=F'(x)$", "$f(x)=1/F(x)$", "$f(x)=F(x)^2$"],
    answer: "A",
    explanation: "Differentiating the cumulative probability recovers the density.",
  },
  {
    prompt: "For continuous $X$, $E[X]$ is:",
    options: ["$\\int f(x)^2dx$", "$\\int_{-\\infty}^{\\infty}x f(x)dx$", "$F(0)$"],
    answer: "B",
    explanation: "Expectation is the density-weighted integral of the variable.",
  },
];

export const PS_RV_NAMED_QUIZ = [
  {
    prompt: "Binomial $n=10$, $p=0.3$: mean equals:",
    options: ["$3$", "$10$", "$0.3$"],
    answer: "A",
    explanation: "$np=3$.",
  },
  {
    prompt: "Same binomial: variance equals:",
    options: ["$0.21$", "$3$", "$2.1$"],
    answer: "C",
    explanation: "$np(1-p)=10\\cdot 0.3\\cdot 0.7=2.1$.",
  },
  {
    prompt: "Poisson with $\\lambda=2$: $P(X=0)$ equals:",
    options: ["$2e^{-2}$", "$e^{-2}$", "$1-e^{-2}$"],
    answer: "B",
    explanation: "$e^{-\\lambda}\\lambda^0/0!$.",
  },
  {
    prompt: "Geometric number of trials until first success with success probability $p=1/3$: mean equals:",
    options: ["$1/3$", "$3$", "$2/3$"],
    answer: "B",
    explanation: "Mean $1/p$ for this convention.",
  },
  {
    prompt: "Normal: if $X\\sim N(\\mu,\\sigma^2)$ and $Z=(X-\\mu)/\\sigma$, then $Z$ is:",
    options: ["Poisson", "Uniform", "Standard normal"],
    answer: "C",
    explanation: "Standardization.",
  },
  {
    prompt: "Empirical rule: about $95\\%$ of normal data lie within:",
    options: ["$2$ standard deviations of the mean", "$0.5$ SD", "$1$ SD"],
    answer: "A",
    explanation: "68-95-99.7 rule.",
  },
  {
    prompt: "Exponential memorylessness: $P(X>s+t\\mid X>s)$ equals:",
    options: ["$P(X>s)$", "$P(X>s+t)$", "$P(X>t)$"],
    answer: "C",
    explanation: "No aging property.",
  },
  {
    prompt: "Counting rare events per unit time is often modeled by:",
    options: ["Uniform continuous", "Poisson", "Binomial with $n=2$ only"],
    answer: "B",
    explanation: "Poisson process counts.",
  },
  {
    prompt: "Number of successes in $n$ independent Bernoulli trials is:",
    options: ["Binomial", "Geometric", "Normal always exact"],
    answer: "A",
    explanation: "Definition of binomial.",
  },
  {
    prompt: "If $X\\sim N(10,4)$ so $\\sigma=2$, then $P(8<X<12)$ is about:",
    options: ["$0.95$", "$0.50$", "$0.68$"],
    answer: "C",
    explanation: "Within one SD of the mean.",
  },
  {
    prompt: "Poisson mean $\\lambda=4$: variance equals:",
    options: ["$4$", "$2$", "$16$"],
    answer: "A",
    explanation: "Mean and variance both $\\lambda$.",
  },
  {
    prompt: "Binomial $n=5$, $p=1/2$: $P(X=5)$ equals:",
    options: ["$5/32$", "$1/32$", "$1/2$"],
    answer: "B",
    explanation: "$(1/2)^5=1/32$.",
  },
  {
    prompt: "Waiting time for a bus with constant hazard rate suggests an:",
    options: ["Exponential distribution", "Binomial distribution", "Hypergeometric only"],
    answer: "A",
    explanation: "Continuous memoryless waits.",
  },
  {
    prompt: "z-score of $x=7$ for $N(5,1)$ equals:",
    options: ["$-2$", "$2$", "$7$"],
    answer: "B",
    explanation: "$(7-5)/1=2$.",
  },
  {
    prompt: "Choosing a distribution: binary outcome per trial with fixed $n$ independent trials points to:",
    options: ["Uniform continuous on $[0,1]$ only", "Exponential", "Binomial"],
    answer: "C",
    explanation: "Classic Bernoulli-sum model.",
  },

  {
    prompt: "A Binomial random variable counts:",
    options: ["Waiting time between Poisson events", "Successes in a fixed number of independent Bernoulli trials", "Any continuous measurement"],
    answer: "B",
    explanation: "Binomial$(n,p)$ counts successes across $n$ independent trials with common success probability $p$.",
  },
  {
    prompt: "For $X\\sim\\operatorname{Bin}(n,p)$, $E[X]$ is:",
    options: ["$n/p$", "$p/n$", "$np$"],
    answer: "C",
    explanation: "The binomial mean is $np$.",
  },
  {
    prompt: "For $X\\sim\\operatorname{Poisson}(\\lambda)$, both mean and variance are:",
    options: ["$\\lambda$", "$\\lambda^2$", "$1/\\lambda$"],
    answer: "A",
    explanation: "Poisson mean and variance both equal the rate parameter.",
  },
  {
    prompt: "The exponential distribution is memoryless, meaning:",
    options: ["$P(X>s+t)=0$", "$P(X>s+t|X>s)=P(X>t)$", "$E[X]=0$"],
    answer: "B",
    explanation: "Remaining waiting time does not depend on time already waited.",
  },
  {
    prompt: "A standard normal random variable has mean and variance:",
    options: ["$1$ and $0$", "$0$ and $0$", "$0$ and $1$"],
    answer: "C",
    explanation: "The standard normal is $N(0,1)$.",
  },
];
